const Contact = () => {
    return <>
        <h1>Formulario de contacto        </h1>
        </>
}

export default Contact